import { Col, Row } from 'antd'
import React from 'react'
function WebHonor() {
    return (
        <Row gutter={100} style={{padding:"30px 60px"}}>
            <Col 
                span={6}
            >
                <img 
                    src='./img/home/honor1.png' 
                    alt=''
                    width={200}
                    height={300}
                />
            </Col>
           
            <Col></Col>
        </Row>
    )
}

export default WebHonor